import {createSlice} from "@reduxjs/toolkit";

let inititalPlusIPVal = {
  stone_type: null,
  stone_shape: null,
  qty: "1",
  length_mm: null,
  width_mm: null,
  client_supplied: null,
  cttw: null,
  setting_style: null,
};
const initialFromValidationsStates = [
  {
    step: 1,
    status: 0,
  },
  {
    step: 2,
    status: 0,
  },
  {
    step: 3,
    status: 0,
  },
  {
    step: 4,
    status: 0,
  },
  {
    step: 5,
    status: 0,
  },
  {
    step: 6,
    status: 0,
  },
  {
    step: 7,
    status: 0,
  },
  {
    step: 8,
    status: 0,
  },
  {
    step: 9,
    status: 0,
  },
  {
    step: 10,
    status: 0,
  },
  {
    step: 11,
    status: 0,
  },
  {
    step: 12,
    status: 0,
  },
];
// Initial state
const initialState = {
  proposal_id: null,
  previous_proposal_id: null,
  proposalStep: 1,
  propStep1Data: null,
  propStep2Data: null,
  propStep3Data: null,
  propStep4Data: null,
  propStep5Data: null,
  propStep6Data: null,
  propStep7Data: null,
  propStep8Data: null,
  propStep9Data: null,
  propStep10Data: null,
  lastSavePoint: null,
  lastSaveStep: null,
  proposalId: null,
  proposalData: null,
  proposalDetails: null,
  filterData: null,
  searchList: [],
  singlePlusRowData: null,
  allPlusRowData: [],
  dataRowsSet: {
    r1: inititalPlusIPVal,
    // r2: inititalPlusIPVal,
    // r3: inititalPlusIPVal,
    // r4: inititalPlusIPVal,
    // r5: inititalPlusIPVal,
  },
  initialDataRowsSet: {
    r1: inititalPlusIPVal,
    r2: inititalPlusIPVal,
    r3: inititalPlusIPVal,
    r4: inititalPlusIPVal,
    r5: inititalPlusIPVal,
  },
  rowToAdd: inititalPlusIPVal,
  dataRows: [],
  isNullishRow: true,
  isNewForm: true,
  pendingProposalsData: null,
  pendingProposalsCount: 0,
  submittedProposalsData: null,
  submittedProposalsCount: 0,
  issuedPoliciesData: null,
  issuedPoliciesCount: 0,
  claimListData: null,
  claimListCount: 0,
  checkoutData: null,
  checkoutRawData: null,
  claimHistoryParentProposal: null,
  endorsementParentProposal: null,
  exhibitionParentProposal: null,
  endorsementList: null,
  endorsementCount: 0,
  exhibitionList: null,
  exhibitionCount: 0,
  remainingAggregate: "$0",
  clientList: [],
  clientCount: 0,
  EMIDetails: null,
  claimFormParentData: null,
  docusignData: null,
  docusignURL: null,
  disableExhibition: false,
  editingSubmitted: false,
  clickedSteps: [],
  formValidations: initialFromValidationsStates, // 0-Neutral, 1-Validated, 2-Invalid
  jewelers_block_type: 0, // 0-SURYA LOGO, 1-AIB LOGO
};

// Actual Slice
export const dataSlice = createSlice({
  name: "dataStore",
  initialState,
  reducers: {
    setDataStore: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const {setDataStore} = dataSlice.actions;

export const selectDataStoreState = (state) => state.dataStore;

export default dataSlice.reducer;
